import {
  ArrowRightCircle,
  Code,
  Globe,
  Info,
  List,
  Mail,
  Shield,
  Users,
} from "react-feather";

const gettingStartedSection = [
  {
    href: "/docs/introduction",
    title: "Introduction",
  },
  {
    href: "/docs/dashboard",
    title: "Dashboard",
  },
  {
    href: "/docs/crm",
    title: "CRM",
    children: [
      {
        href: "/docs/crm/introduction",
        title: "Introduction",
      },
      {
        href: "/docs/crm/levels",
        title: "User Levels and Permissions",
      },
    ],
  },
  {
    href: "/docs/sims",
    title: "SIMs",
    children: [
      {
        href: "/docs/sims/introduction",
        title: "Introduction",
      },
      {
        href: "/docs/sims/lifecycle",
        title: "SIM Lifecycle",
      },
      {
        href: "/docs/sims/panel",
        title: "SIMs Panel",
      },
      {
        href: "/docs/sims/provisioning",
        title: "SIM Provisioning",
      },
      {
        href: "/docs/sims/profile",
        title: "SIM Profile",
      },
      {
        href: "/docs/sims/transfer",
        title: "SIM Transfers",
      },
    ],
  },
  {
    href: "/docs/watchdog",
    title: "Watchdogs",
    children: [
      {
        href: "/docs/watchdog/introduction",
        title: "Introduction",
      },
      {
        href: "/docs/watchdog/add",
        title: "Add Watchdogs",
      },
      {
        href: "/docs/watchdog/remove",
        title: "Remove All Watchdogs",
      },
      {
        href: "/docs/watchdog/reset",
        title: "Reset Watchdog",
      },
      {
        href: "/docs/watchdog/block-suspension",
        title: "Block Suspension",
      },
      {
        href: "/docs/watchdog/alerts",
        title: "Alerts",
      },
    ],
  },
  {
    href: "/docs/reports",
    title: "Reports",
    children: [
      {
        href: "/docs/reports/introduction",
        title: "Introduction",
      },
      {
        href: "/docs/reports/single",
        title: "Single Report",
      },
      {
        href: "/docs/reports/automated",
        title: "Automated Reports",
      },
      {
        href: "/docs/reports/history",
        title: "Report History",
      },
    ],
  },
  {
    href: "/docs/offers",
    title: "Offers",
    children: [
      {
        href: "/docs/offers/introduction",
        title: "Introduction",
      },
      {
        href: "/docs/offers/create",
        title: "Create Offer",
      },
    ],
  },
  {
    href: "/docs/account",
    title: "Account",
    children: [
      {
        href: "/docs/account/billingProducts",
        title: "Billing Products",
      },
      {
        href: "/docs/account/invoices",
        title: "Invoices",
      },
      {
        href: "/docs/account/orders",
        title: "Orders",
      },
      {
        href: "/docs/account/emails",
        title: "Emails",
      },
      {
        href: "/docs/account/customFields",
        title: "Custom Fields",
      },
    ],
  },
  {
    href: "/docs/api",
    title: "API",
  },
  {
    href: "/docs/terms-and-conditions",
    title: "Terms and Conditions",
  },
  {
    href: "/docs/privacy-policy",
    title: "Privacy Policy",
  },
];

const navItems = [
  {
    title: "",
    pages: gettingStartedSection,
  },
];

export default navItems;
